<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> All users
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
                <th>E-mail</th>
                <th>Roles</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="user in users">
                  <td>{{user.id}}</td>
                  <td>{{user.name}}</td>
                  <td>{{user.email}}</td>
                  <td>
                    <span v-for="role in user.roles" class="badge badge-success">{{role.name}}</span>
                  </td>
                  <td>
                    <i class="fa fa-edit fa-lg action" @click="editUser(user)"></i>
                    <i class="fa fa-trash fa-lg action" @click="deleteUser(user)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--<nav>-->
              <!--<ul class="pagination">-->
                <!--<li class="page-item"><a class="page-link" href="#">Prev</a></li>-->
                <!--<li class="page-item active">-->
                  <!--<a class="page-link" href="#">1</a>-->
                <!--</li>-->
                <!--<li class="page-item"><a class="page-link" href="#">2</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">3</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">4</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">Next</a></li>-->
              <!--</ul>-->
            <!--</nav>-->
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
    <modal  :backdrop="false" title="Edit user" large class="modal-info" v-model="isEditingUser" @ok="(selectedUser)" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Edit user</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <form  method="post" enctype="multipart/form-data" class="form-horizontal ">
          <div class="form-group row">
            <label class="col-md-3 form-control-label">E-mail</label>
            <div class="col-md-9">
              <p class="form-control-static">{{selectedUser.email}}</p>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-control-label" for="text-input">Name</label>
            <div class="col-md-9">
              <input type="text" id="text-input" name="text-input" class="form-control" placeholder="Name" v-model="selectedUser.name">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-control-label" for="textarea-input">Notes</label>
            <div class="col-md-9">
              <textarea id="textarea-input" v-model="selectedUser.notes" name="textarea-input" rows="9" class="form-control" placeholder="Content.."></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-control-label">Roles</label>
            <div class="col-md-9">
              <div class="checkbox" v-for="role in roles">
                <label for="checkbox1">
                  <input type="checkbox" id="checkbox1" :name="role.name" :value="role" v-model="selectedUser.activeRoles"> {{role.name}}
                </label>
              </div>
            </div>
          </div>

            <div class="form-group row">
          <label class="col-md-3 form-control-label">Change password</label>
          <div class="col-md-9">

        <div>
            <input type="password" placeholder="New password"  v-model="password.fieldOne" />
      </div>

              <input class="passwordInput" type="password"  placeholder="Repeat new password"  v-model="password.fieldTwo" />
                <div v-show="!passValid">Passwords do not match!</div>
                <div v-show="passNotValidSize">Password must contain 5 symbols!</div>
          <div>

              <button class="btn btn-primary passwordInput" type="button" v-show="passValid" @click="changePassword()">Update password</button>
          </div>
          </div>
        </div>

          <hr>

          <hr>
          <div class="form-group row justify-content-center">
            <label class="col-md-2 form-control-label text-center logs-title">Logs</label>
            <div class="col-md-12">
              <table class="table table-bordered table-striped table-condensed logs-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Action</th>
                    <th>Date</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, index) in user_logs" :key="index">
                    <td>{{log.id}}</td>
                    <td>{{log.action_type}}</td>
                    <td>{{log.date}}</td>
                    <td class="link-to-log" @click="openProject(log.project_id)" v-if="log.project_id">project</td>
                    <td class="link-to-log" @click="openContract(log.contract_id)" v-if="log.contract_id">contract</td>
                    <td class="link-to-log" @click="openTemplate(log.template_id)" v-if="log.template_id">template</td>
                    <td v-if="!log.project_id && !log.contract_id && !log.template_id">deleted</td>
                  </tr>
                </tbody>
              </table>
              <div id="page">
                <template class="temp">
                  <v-page :setting="pageSet" @page-change="pageChange"></v-page>
                </template>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click="updateUser()">Save changes</button>
        <button type="button" class="btn btn-secondary" @click="isEditingUser = false">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
import VueNotifications from 'vue-notifications';
import vPage from '../libraries/vPage/vPage.vue';

export default {
  name: 'users',
  components: {
    modal,
    vPage
  },
  data() {
    return {
      password: {
        fieldOne: '',
        fieldTwo: ''
      },
      selectedUser: false,
      isEditingUser: false,
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
      pageSet: {
        totalRow: '',
        language: 'en',
        pageSizeMenu: [10, 20, 50, 100],
        pageNumber: 1,
        pageSize: 10,
        currentPage: ''
      },
      user_logs: []
    };
  },
  computed: {
    ...mapGetters('Identities', [
      'users',
      'roles',
      'singleUser',
      'deleted_user',
      'updated_user',
      'password_change'
    ]),
    passNotValidSize: function () {
      return this.password.fieldOne.length > 0 && this.password.fieldOne.length < 5;
    },
    passValid: function () {
      return this.password.fieldOne == this.password.fieldTwo;
    },
    ...mapGetters('Clients', ['allContracts']),
    ...mapGetters('Templates', ['templates_dropdown'])
  },
  watch: {
    singleUser: 'singleUserLoaded',
    roles: 'onRolesLoaded',
    deleted_user: 'deletedUserStatus',
    updated_user: 'updateUserStatus',
    password_change: 'passwordChangeStatus',
    isEditingUser: function () {
      // if (this.isEditingUser == true) {
      //   $('.projects-div').css('z-index', '0');
      // } else {
      //   $('.projects-div').css('z-index', '1');
      // }
    }

  },

  methods: {
    ...mapActions('Identities', [
      'LOAD_USERS',
      'LOAD_ROLES',
      'LOAD_SINGLE_USER',
      'UPDATE_USER',
      'DELETE_USER',
      'CHANGE_PASSWORD'
    ]),
    ...mapActions('Clients', ['GET_ALL_CONTRACTS']),
    ...mapActions('Templates', ['TEMPLATES_DROPDOWN']),
    pageChange(pInfo) {
      this.pageSet.pageNumber = pInfo.pageNumber;
      this.pageSet.pageSize = pInfo.pageSize;
      this.paginateLogs();
      //        console.log(pInfo);
    },
    paginateLogs() {
      this.user_logs = [];
      if (this.pageSet.pageSize >= this.pageSet.totalRow) {
        this.user_logs = this.selectedUser.user_logs;
        return;
      }
      for (const i in this.selectedUser.user_logs) {
        if ((this.pageSet.pageNumber * this.pageSet.pageSize) >= i && ((this.pageSet.pageNumber - 1) * this.pageSet.pageSize) <= i) {
          this.user_logs.push(this.selectedUser.user_logs[i]);
        }
      }
    },
    openProject(id) {
      $('.modal-open').css({ overflow: 'scroll', paddingRight: '0px' });
      this.isEditingUser = false;
      this.$router.push({ name: 'ProjectTabPlanning', params: { id: id } });
    },
    openContract(id) {
      let exists = false;
      for (const i in this.allContracts) {
        if (this.allContracts[i].id == id) {
          exists = true;
          break;
        }
      }
      if (exists) {
        $('.modal-open').css({ overflow: 'scroll', paddingRight: '0px' });
        this.isEditingUser = false;
        this.$router.push({ name: 'EditContract', params: { id: id } });
      } else {
        this.showErrorMsg({ title: 'Failed to open contract', message: 'Contract has been deleted!' });
      }
    },
    openTemplate(id) {
      let exists = false;
      for (const i in this.templates_dropdown) {
        if (this.templates_dropdown[i].id == id) {
          exists = true;
          break;
        }
      }
      if (exists) {
        $('.modal-open').css({ overflow: 'scroll', paddingRight: '0px' });
        this.isEditingUser = false;
        this.$router.push({ name: 'EditTemplate', params: { id: id } });
      } else {
        this.showErrorMsg({ title: 'Failed to open template', message: 'Template has been deleted!' });
      }
    },
    singleUserLoaded() {
      this.selectedUser = this.singleUser;
      if (this.selectedUser) {
        this.pageSet.totalRow = this.selectedUser.user_logs.length;
        this.paginateLogs();
        this.isEditingUser = true;
        this.onRolesLoaded();
      } else {
        this.isEditingUser = false;
        this.LOAD_USERS();
      }
    },
    onRolesLoaded() {
      if (this.selectedUser) {
        this.selectedUser.activeRoles = [];
        for (let i = 0; i < this.roles.length; i++) {
          if (this.haveRole(this.roles[i])) {
            this.selectedUser.activeRoles.push(this.roles[i]);
          }
        }
      }
    },
    changePassword() {
      // console.log(this.password);
      // return console.log(this.selectedUser);
      this.CHANGE_PASSWORD({ password: this.password, userid: this.selectedUser.id });
    },

    deletedUserStatus() {
      if (this.deleted_user.status == 'success') {
        this.showSuccessMsg({ title: 'User delete status', message: `User ${this.deleted_user.data.name} deleted!` });
      }
      if (this.deleted_user.status == 'error') {
        this.showErrorMsg({ title: 'User delete status', message: 'Failed to delete user!' });
      }
    },
    updateUserStatus() {
      if (this.updated_user.status == 'success') {
        this.showSuccessMsg({ title: 'User update status', message: `User ${this.updated_user.data.name} updated!` });
      }
      if (this.updated_user.status == 'error') {
        this.showErrorMsg({ title: 'User update status', message: 'Failed to update user!' });
      }
    },
    passwordChangeStatus() {
      if (this.password_change.status == 'success') {
        this.showSuccessMsg({ title: 'Password update status', message: 'Password updated!' });
      }
      if (this.password_change.status == 'error') {
        this.showErrorMsg({ title: 'password update status', message: 'Failed to update user!' });
      }
    },
    editUser(user) {
      this.LOAD_SINGLE_USER(user.id);
    },
    haveRole(role) {
      if (this.selectedUser) {
        for (let i = 0; i < this.selectedUser.roles.length; i++) {
          const otherRole = this.selectedUser.roles[i];
          if (role.id == otherRole.id) {
            return true;
          }
        }
      }
      return false;
    },
    updateUser() {
      if (this.selectedUser) {
        this.UPDATE_USER(this.selectedUser);
      }
    },
    deleteUser(user) {
      const vm = this;
      this.$dialog.confirm(`Delete user - ${user.name}?`, this.confirmation_options)
        .then(() => {
          vm.DELETE_USER(user.id);
        })
        .catch(() => {

        });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.LOAD_USERS();
    this.LOAD_ROLES();
    this.GET_ALL_CONTRACTS();
    this.TEMPLATES_DROPDOWN();
  }
};

</script>

<style lang="scss" scope>
  .logs-title {
    font-size: 20px;
  }
  .action {
    margin-left: 5px;

    &:hover {
      cursor: pointer;
      color: #ee0044;
     }
  }
  .logs-table td, th {
    padding: 5px;
    text-align: center;
  }
  .logs-table th {
    font-weight: bold;
    text-align: center;
  }
  .link-to-log:hover {
    cursor: pointer;
    color: #ee0044;
  }
  .passwordInput {
    margin-top: 10px;
  }
</style>
